import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from 'react-oidc-context';
import Header from './components/Header';
import Callback from './Pages/Callback/Callback';
import Login from './Pages/Login/Login';
import StudyJapanese from './Pages/StudyJapanese/StudyJapanese';
import LearnReact from './Pages/LearnReact/LearnReact';
import Home from './Pages/Home/Home';
import ComponentShowcase from './Pages/ComponentShowcase/ComponentShowcase';
import Pachinko from './Pages/Pachinko/Pachinko';
import BalloonRelease from './Pages/BalloonRelease/BalloonRelease';
import PrivateRoute from './Pages/PrivateRoute/PrivateRoute';

const AppContainer = styled.div`
    background-color: #e1c2f0;
    min-height: 100vh;
`;

const AppBody = styled.div`
    padding-left: 3rem;
    padding-right: 3rem;
`;

const App: React.FC = () => {
    const auth = useAuth();

    if (auth.isLoading) {
        return <div>Loading...</div>;
    }

    if (auth.error) {
        return <div>Error: {auth.error.message}</div>;
    }

    return (
        <div className="App">
            <AppContainer>
                <BrowserRouter>
                    <Header isAuthenticated={auth.isAuthenticated} />
                    <AppBody data-testid="app-body">
                        <Switch>
                            <Route exact path="/login">
                                <Login />
                            </Route>
                            <Route exact path="/callback">
                                <Callback />
                            </Route>
                            <PrivateRoute exact path="/study-japanese/add">
                                <StudyJapanese />
                            </PrivateRoute>
                            <PrivateRoute exact path="/study-japanese/study">
                                <StudyJapanese />
                            </PrivateRoute>
                            <PrivateRoute exact path="/study-japanese/list">
                                <StudyJapanese />
                            </PrivateRoute>
                            <PrivateRoute exact path="/study-japanese">
                                <StudyJapanese />
                            </PrivateRoute>
                            <PrivateRoute exact path="/learn-react">
                                <LearnReact />
                            </PrivateRoute>
                            <PrivateRoute exact path="/showcase">
                                <ComponentShowcase />
                            </PrivateRoute>
                            <PrivateRoute exact path="/pachinko">
                                <Pachinko />
                            </PrivateRoute>
                            <PrivateRoute exact path="/balloon-release">
                                <BalloonRelease />
                            </PrivateRoute>
                            <PrivateRoute exact path="/">
                                <Home />
                            </PrivateRoute>
                        </Switch>
                    </AppBody>
                </BrowserRouter>
            </AppContainer>
        </div>
    );
};

export default App;
